import AdjustMany from './components/adjust_many/AdjustMany';
export default () => {
  return <AdjustMany />;
};
